import { convertCreative, isRecognizedConfig } from '../../../../../configs';
import type { CreativeType as ConfigCreativeType } from '../../../../../configs/creativeTypes';
import type { TagSheetAd, TagSheetLineItem } from '../types';
import { getPermittedAdTypesForLineItem, resolveAdForLineItem } from '../utils/ads';
import { isSupportedCreativeType } from '../utils/creative';
import {
  getAdTypeNotPermittedMessage,
  getCreativeTypeNotPermittedMessage,
  getCreativeTypeNotSupportedByMutationMessage,
} from './constants';
import type { AdValidationError } from './types';

export const getAdTypeValidationErrors = (
  ad: TagSheetAd,
  lineItem: TagSheetLineItem
): Pick<AdValidationError, 'adType' | 'creativeType' | 'unsupportedCreativeType'> => {
  const errors: Pick<AdValidationError, 'adType' | 'creativeType' | 'unsupportedCreativeType'> = {};
  const permittedAdTypes = getPermittedAdTypesForLineItem(lineItem);
  const creativeTypeDisplayName = ad.creative.creativeType.displayName;
  const creativeTypeKey = ad.creative.creativeType.key as ConfigCreativeType;
  const resolution = resolveAdForLineItem(creativeTypeKey, lineItem);

  if (!isRecognizedConfig(ad.adType) || !permittedAdTypes.includes(ad.adType.key)) {
    errors.adType = getAdTypeNotPermittedMessage(ad.adType.displayName, lineItem.adProduct.displayName);
  }

  if (!resolution) {
    errors.creativeType = getCreativeTypeNotPermittedMessage(creativeTypeDisplayName);
  } else if (!isSupportedCreativeType(resolution.creativeType)) {
    errors.unsupportedCreativeType = getCreativeTypeNotSupportedByMutationMessage(
      convertCreative(resolution.creativeType).displayName
    );
  }

  return errors;
};
